"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMentionSuggestions = exports.updateArticleCall = exports.uploadFeaturedImage = exports.deleteArticle = exports.createArticle = void 0;
var axios_1 = __importDefault(require("axios"));
function createArticle(_a) {
    var payload = _a.payload;
    return axios_1.default.post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/posts"), payload.data, {
        headers: {
            Authorization: 'Bearer ' + payload.token,
            'Content-Type': 'application/json'
        }
    });
}
exports.createArticle = createArticle;
function deleteArticle(_a) {
    var payload = _a.payload;
    return axios_1.default.delete("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/posts/").concat(payload.id, "?force=true"), {
        headers: {
            Authorization: 'Bearer ' + payload.token,
            'Content-Type': 'application/json'
        }
    });
}
exports.deleteArticle = deleteArticle;
function uploadFeaturedImage(_a) {
    var payload = _a.payload;
    var token = payload.token, file = payload.file;
    var formData = new FormData();
    formData.append('file', file);
    return axios_1.default.post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/media"), formData, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'multipart/form-data'
        }
    });
}
exports.uploadFeaturedImage = uploadFeaturedImage;
function updateArticleCall(_a) {
    var payload = _a.payload;
    var token = payload.token, data = payload.data, id = payload.id;
    return axios_1.default.post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/posts/").concat(id), data, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        }
    });
}
exports.updateArticleCall = updateArticleCall;
var getMentionSuggestions = function (userId) {
    return axios_1.default.get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/user/for-mentions/").concat(userId));
};
exports.getMentionSuggestions = getMentionSuggestions;
